import api from "api";
import { User } from "types";

export interface AgeGradeMember extends User {
  // Define any additional properties specific to an age grade member
}

export interface AgeGradeInfo {
  id: number;
  name: string;
  min_age: number;
  max_age: number;
}

export interface AgeGradeResponse {
  message: string;
  members: AgeGradeMember[];
  age_grade?: AgeGradeInfo;
}

/**
 * Get members of the current user's age grade
 */
export const getAgeGradeMembers = async (): Promise<AgeGradeResponse> => {
  try {
    const response = await api.get("/age-grade-members");
    return response.data;
  } catch (error) {
    console.error("Error fetching age grade members:", error);
    throw error;
  }
};
